import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SubSink } from 'subsink';
import { HotelService } from '../../../../../hotel.service';

@Component({
    selector: 'app-rating-filter',
    templateUrl: './rating-filter.component.html',
    styleUrls: ['./rating-filter.component.scss']
})
export class RatingFilterComponent implements OnInit {

        starForm: FormGroup;
        starRating: number = 0;
        hotels: {}[] = [];
        starsTemp: Array<any> = [];
        availableFilters = [];
        protected subs = new SubSink();
      
        constructor(
          private fb: FormBuilder,
          private hotelService: HotelService,
          private cdr: ChangeDetectorRef
        ) {}
      
        ngOnInit() {
          this.createForm();
          this.availableFilters = this.hotelService.availableOptions['stars'];
          this.subs.sink = this.hotelService.clearRating.subscribe(res => {
            if (res) {
              this.clearRatingFilter();
            }
          });
        }
      
        createForm() {
          this.starForm = this.fb.group({
            star1: false, star2: false, star3: false, star4: false, star5: false
          });
        }
      
        get starControls() {
          return this.starForm.controls;
        }
      
        onStarRatingChange(rating: number) {
          this.starRating = rating;
          this.filterByStars();
        }
      
        filterByStars() {
          this.hotelService.hotels.next([]);
          this.starsTemp = [];
          Object.keys(this.starControls).forEach((key, i) => {
            const isChecked = this.starRating === i + 1; // Match the rating with the star level
            this.starControls[key].setValue(isChecked, { emitEvent: false }); // Update form control without emitting change event
            this.starsTemp.push({ stars: i+1, name: `${i} Star`, type: 'star', isChecked });
          });
          this.hotelService.stars.next(this.starsTemp);
          this.hotelService.filterByStar();
        }
      
        clearRatingFilter() {
          this.starForm.patchValue({
            // star0: false,
            star1: false,
            star2: false,
            star3: false,
            star4: false,
            star5: false
          });
          this.starRating = 0; // Reset the star rating
          this.hotelService.stars.next([]);
          this.hotelService.filterByStar();
        }
      
        ngOnDestroy() {
          this.subs.unsubscribe();
        }
      }
